import { RouterView } from 'vue-router';
import { shallowRef } from 'vue';

import Home from '@/routes/Home.vue';
import Login from '@/routes/auth/Login.vue';
import LoginCallback from '@/routes/auth/LoginCallback.vue';

import ListingCI from '@/routes/ci/Listing.vue';
import CIOverview from '@/routes/ci/CIOverview.vue';
import PublishedCI from '@/routes/ci/Published.vue';
import AddCI from '@/routes/ci/Add.vue';
import LayoutCI from '@/routes/ci/Layout.vue';
import DraftCI from '@/routes/ci/Draft.vue';

import EnvironmentTopNav from '@/routes/ci/environment/EnvironmentTopNav.vue';
import Camera from '@/routes/ci/environment/camera/Camera.vue';
import DraftConfig from '@/routes/ci/config/Config.vue';

import ListingModel from '@/routes/model/Listing.vue';
import AddModel from '@/routes/model/Add.vue';
import Model from '@/routes/model/Model.vue';

import ListingMaterial from '@/routes/material/Listing.vue';
import AddMaterial from '@/routes/material/Add.vue';
import Material from '@/routes/material/Material.vue';

import ListingTexture from '@/routes/texture/Listing.vue';
import AddTexture from '@/routes/texture/Add.vue';
import Texture from '@/routes/texture/Texture.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: shallowRef(Home),
    meta: { showInNav: false, authRequired: 'true' },
  },
  {
    path: '/login',
    name: 'Login',
    component: shallowRef(Login),
  },
  {
    path: '/login/callback',
    name: 'LoginCallback',
    component: shallowRef(LoginCallback),
  },
  {
    path: '/configurable-items',
    name: 'Configurable Items',
    component: shallowRef(RouterView),
    children: [
      {
        path: '',
        name: 'CI Listing',
        query: { q: ':search', sortBy: ':sortBy', tags: ':tags' },
        component: shallowRef(ListingCI),
        fullPath: '/configurable-items/',
        meta: { showInNav: true, authRequired: 'true' },
      },
      {
        path: 'create',
        name: 'Create CI',
        component: shallowRef(AddCI),
        fullPath: '/configurable-items/create',
        meta: { showInNav: true, authRequired: 'true' },
      },
      {
        path: ':ciId',
        component: shallowRef(LayoutCI),
        children: [
          {
            path: '',
            name: 'CI Overview',
            component: shallowRef(CIOverview),
            meta: { authRequired: 'true' },
            props: true,
          },
          {
            path: 'draft',
            name: 'CI Draft',
            component: shallowRef(DraftCI),
            meta: { authRequired: 'true' },
            props: true,
            children: [
              {
                name: 'Configuration Setup',
                path: 'config',
                meta: {
                  authRequired: true,
                },
                components: {
                  default: shallowRef(DraftConfig),
                },
              },
              {
                name: 'Camera Options',
                path: 'environment/camera',
                meta: { authRequired: true },
                components: {
                  top: shallowRef(EnvironmentTopNav),
                  default: shallowRef(Camera),
                },
              },
            ],
          },
          {
            path: 'version/:versionId',
            name: 'CI Published',
            component: shallowRef(PublishedCI),
            meta: { authRequired: 'true' },
          },
        ],
      },
    ],
    meta: { showInNav: true, isOpen: false },
  },
  {
    path: '/models',
    component: shallowRef(RouterView),
    name: 'Models',
    children: [
      {
        path: '',
        name: 'Model Listing',
        query: { q: ':search', sortBy: ':sortBy' },
        component: shallowRef(ListingModel),
        fullPath: '/models/',
        meta: { showInNav: true, authRequired: 'true' },
      },
      {
        path: 'create',
        name: 'Upload Model',
        component: shallowRef(AddModel),
        fullPath: '/models/create',
        meta: { showInNav: true, authRequired: 'true' },
      },
      { path: ':modelId', name: 'Model Overview', component: shallowRef(Model), meta: { authRequired: 'true' } },
    ],
    meta: { showInNav: true, isOpen: false },
  },
  {
    path: '/materials',
    component: shallowRef(RouterView),
    name: 'Materials',
    children: [
      {
        path: '',
        name: 'Material Listing',
        query: { q: ':search', sortBy: ':sortBy' },
        component: shallowRef(ListingMaterial),
        fullPath: '/materials/',
        meta: { showInNav: true, authRequired: 'true' },
      },
      {
        path: 'create',
        name: 'Create Material',
        component: shallowRef(AddMaterial),
        fullPath: '/materials/create',
        meta: { showInNav: true, authRequired: 'true' },
      },
      {
        path: ':materialId',
        name: 'Material Overview',
        component: shallowRef(Material),
        meta: { authRequired: 'true' },
      },
    ],
    meta: { showInNav: true, isOpen: false, authRequired: 'true' },
  },
  {
    path: '/textures',
    component: shallowRef(RouterView),
    name: 'Textures',
    children: [
      {
        path: '',
        name: 'Texture Listing',
        query: { q: ':search', sortBy: ':sortBy' },
        component: shallowRef(ListingTexture),
        fullPath: '/textures/',
        meta: { showInNav: true, authRequired: 'true' },
      },
      {
        path: 'create',
        name: 'Create Texture',
        component: shallowRef(AddTexture),
        fullPath: '/textures/create',
        meta: { showInNav: true, authRequired: 'true' },
      },
      { path: ':textureId', name: 'Texture Overview', component: shallowRef(Texture), meta: { authRequired: 'true' } },
    ],
    meta: { showInNav: true, isOpen: false, authRequired: 'true' },
  },
];

const state = () => ({ routes });

export default {
  namespaced: true,
  strict: true,
  state,
};
